import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticsloanrepaymentcomparism',
  templateUrl: './analyticsloanrepaymentcomparism.component.html',
  styleUrls: ['./analyticsloanrepaymentcomparism.component.css']
})
export class AnalyticsloanrepaymentcomparismComponent implements OnInit {
  @Input('details') details: any;
  @Input('loan') loan: any;
  percent_early: number;
  percent_lateness: number;
  percent_loans: number;
  lateness_type: any;

  constructor() {
  }

  ngOnInit() {
    this.percent_lateness = this.details.data.percent_lateness;
    this.percent_early = this.details.data.percent_early;
    this.percent_loans = this.details.data.percent_loans;
    if (this.percent_lateness == 0 && this.percent_lateness <= 25) {
      this.lateness_type = "danger"
    } else if (this.percent_lateness > 25 && this.percent_lateness <= 50) {
      this.lateness_type = 'danger'
    } else if (this.percent_lateness > 50 && this.percent_lateness <= 75) {
      this.lateness_type = 'warning'
    } else {
      this.lateness_type = 'success'
    }
    //console.log(this.lateness_type)
  }

}
